import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "to", "activeClassName", "activeStyle", "activePropName", "match", "router", "exact", "onClick", "target", "children"];
import useEventCallback from '@restart/hooks/useEventCallback';
import React, { forwardRef } from 'react';
import warning from 'tiny-warning';
import useRouter from './useRouter';

// TODO: Try to type this & simplify those types in next breaking change.
import { jsx as _jsx } from "react/jsx-runtime";
var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'a' : _ref$as,
    to = _ref.to,
    activeClassName = _ref.activeClassName,
    activeStyle = _ref.activeStyle,
    activePropName = _ref.activePropName,
    propsMatch = _ref.match,
    propsRouter = _ref.router,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? false : _ref$exact,
    onClick = _ref.onClick,
    target = _ref.target,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _ref2 = useRouter() || {
      match: propsMatch,
      router: propsRouter
    },
    router = _ref2.router,
    match = _ref2.match;
  var handleClick = useEventCallback(function (event) {
    if (onClick) {
      onClick(event);
    }

    // Don't do anything if the user's onClick handler prevented default.
    // Otherwise, let the browser handle the link with the computed href if the
    // event wasn't an unmodified left click, or if the link has a target other
    // than _self.
    if (event.defaultPrevented || event.metaKey || event.altKey || event.ctrlKey || event.shiftKey || event.button !== 0 || target && target !== '_self') {
      return;
    }
    event.preventDefault();

    // FIXME: When clicking on a link to the same location in the browser, the
    // actual becomes a replace rather than a push. We may want the same
    // handling – perhaps implemented in the Farce protocol.
    router.push(to);
  });
  if (process.env.NODE_ENV !== "production" && typeof Component !== 'function') {
    for (var _i = 0, _arr = ['component', 'Component']; _i < _arr.length; _i++) {
      var wrongPropName = _arr[_i];
      var wrongPropValue = props[wrongPropName];
      if (!wrongPropValue) {
        continue;
      }
      process.env.NODE_ENV !== "production" ? warning(false, "Link to ".concat(JSON.stringify(to), " with `").concat(wrongPropName, "` prop `").concat(wrongPropValue.displayName || wrongPropValue.name || 'UNKNOWN', "` has an element type that is not a component. The expected prop for the link component is `as`.")) : void 0;
    }
  }
  var href = router.createHref(to);
  var childrenIsFunction = typeof children === 'function';
  if (childrenIsFunction || activeClassName || activeStyle || activePropName) {
    var toLocation = router.createLocation(to);
    var active = router.isActive(match, toLocation, {
      exact: exact
    });
    if (childrenIsFunction) {
      var add = {
        href: href,
        active: active,
        onClick: handleClick
      };
      return children(add);
    }
    if (active) {
      if (activeClassName) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        props.className = props.className ? "".concat(props.className, " ").concat(activeClassName) : activeClassName;
      }
      if (activeStyle) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        props.style = Object.assign({}, props.style, activeStyle);
      }
    }
    if (activePropName) {
      props[activePropName] = active;
    }
  }
  return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
    href: href,
    ref: ref,
    onClick: handleClick // This overrides props.onClick.
    ,

    children: children
  }));
});

// eslint-disable-next-line react/prefer-stateless-function

export default Link;